<template>
  <div class="item">
    <div class="field-narrow">{{ index + 1 }}</div>
    <div class="field-medium">{{ item.name }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.updatetime) }}</div>
    <div class="field-medium">{{ convertGMT0toGMT8(item.createtime) }}</div>
    <div class="field-medium">
      <button type="button" @click="viewItem" class="btn">{{ $t('information') }}</button>
      <button type="button" @click="editItem" class="btn" v-if="getPermission() < 3">
        {{ $t('edit') }}</button>
      <button type="button" @click="deleteItem" class="btn" v-if="getPermission() < 3">
        {{ $t('delete') }}</button>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import { deleteData } from '../utils/api';
import { getPermission } from '../../User';
import { convertGMT0toGMT8 } from '../utils/stringValid';

export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    const apiBaseUrl = inject('apiBaseUrl');
    const url = 'project';
    return { t, apiBaseUrl, url };
  },
  methods: {
    convertGMT0toGMT8,
    getPermission,
    viewItem() {
      this.$router.push(`/${this.url}/${this.item.id}`);
    },
    editItem() {
      this.$router.push(`/${this.url}/edit/${this.item.id}`);
    },
    async deleteItem() {
      try {
        const data = await deleteData(
          this.t,
          `${this.apiBaseUrl}/delete/${this.url}`,
          this.item.id,
        );
        if (data) {
          this.$emit('remove-item', this.item);
        }
      } catch (error) {
        console.error('Error during deletion:', error);
      }
    },
  },
};
</script>

<style>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: normal;
  padding: 10px;
}

.field-narrow {
  flex: 1;
  text-align: center;
}

.field-medium {
  flex: 2;
  text-align: center;
}
</style>
